import { useEffect, useState, useRef } from 'react'

// locals
import LactationService from 'service/LactationService'
import { IGetLactationRoomTimeTableList } from 'types/LactationType'
import DateUtil from 'utils/DateUtil'
import { groupBy } from 'utils/Miscellaneous'

export default function useGetLactationRoomResTable(
  locationId: number,
  lactationRoomId: number,
  dateFromList: Date,
  isCalendar: boolean = false
) {
  const [timeTable, setTimeTable] = useState<IGetLactationRoomTimeTableList[] | []>([])
  const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
  const [tableWeek, setTableWeek] = useState(selectedDate)
  const [availableDates, setAvailableDates] = useState({ start: 0, end: 0 })
  const [selectedReservation, setSelectedReservation] = useState<IGetLactationRoomTimeTableList>()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (!isMountedRef.current) return
    LactationService.getLactationServiceDetailByLocationId(locationId).then((res) => {
      if (isMountedRef.current) {
        setAvailableDates({
          start: res.data.reservationStartDay,
          end: res.data.reservationEndDay,
        })
      }
    })
  }, [locationId])

  useEffect(() => {
    if (!isMountedRef.current) return
    setLoading(true)
    LactationService.getLactationRoomReservationTableList({
      lactationRoomId: lactationRoomId,
      startDate: DateUtil.formatDateToString(tableWeek.start),
      endDate: DateUtil.formatDateToString(tableWeek.end),
    })
      .then((res) => {
        if (isMountedRef.current) {
          setTimeTable(res.data)
        }
      })
      .finally(() => {
        if (isMountedRef.current) {
          setLoading(false)
        }
      })

    /* Reset selected appointment time */
    if (!isCalendar && isMountedRef.current) setSelectedReservation(undefined)
  }, [lactationRoomId, tableWeek.start, tableWeek.end, isCalendar])

  useEffect(() => {
    const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
    setTableWeek(selectedDate)
  }, [dateFromList, lactationRoomId])

  const dailyAppointments: [] | Record<string, IGetLactationRoomTimeTableList[]> = !!timeTable.length
    ? groupBy(timeTable, (v) => DateUtil.formatStringToDate(v.reservationStartHour))
    : []

  return {
    availableDates,
    tableWeek,
    setTableWeek,
    selectedReservation,
    setSelectedReservation,
    sidebarVisible,
    setSidebarVisible,
    dailyAppointments,
    loading,
  }
}
